<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">阿尔法认知（公司）</span>
      <span class="zn-text-grey">会把内容解析到人选 阿尔法认知里</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="font-size:16px;padding-bottom:10px;color:#444;">
        当前人选：{{radish.姓名}}（{{radish.公司}}）
      </div>
      <div v-loading="submiting"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="zn-content-item" v-if="company._id">
          <div class="zn-content-item" v-for="(field, k) in alphaRenzhiFields" :key="k">
            <div class="zn-text-grey">{{ field.label }}：</div>
            <el-input
              type="textarea"
              :rows="2"
              :placeholder="field.placeholder"
              v-model="formData[field.value]">
            </el-input>
          </div>
        </div>
        <div v-else class="zn-content-item-inline" style="padding-left:15px">
          <div class="zn-text-grey" style="width: 120px">请填写正确的公司：</div>
          <el-input v-model="radish.公司" size="mini" @blur="searchCompany" style="width: 200px"></el-input>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="showChooseCompany"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="450px"
      class="radish-dia"
    >
      <div style="font-size:12px;color:#888;margin-bottom:5px">
        系统没有查到您填写的公司
        <span v-show="similarCompany.length > 0">，您要找到是不是以下公司，如果不是</span>
        <el-button type="text" size="mini"
          @click="gotoCompany"
          style="font-size:13px"
        >请新建</el-button>
      </div>
      <div class="radish-dia-body">
        <div style="padding-bottom:10px;">
          <el-button v-for="(com, k) in similarCompany" :key="k" type="text" size="mini"
            @click="chooseCompany(com.简称)"
            style="margin:0 20px 5px 0;font-size:13px"
          >
            {{com.公司名称}}({{com.简称}})
          </el-button>
        </div>
      </div>
    </el-dialog>
    <div class="zn-template-submit" @click="submit">完成填写</div>
  </div>
</template>
<script>
import {alphaRenzhiFields} from './renzhi_fields'
export default {
  props: {
    componentName: String,
    item: Object,
  },
  data() {
    return {
      formData: {},
      alphaRenzhiFields,
      submiting: false,
      radish: {},
      company: {},
      alphaRenzhi: {
        公司备注: '',
        阿尔法认知: [],
      },
      showChooseCompany: false,
      similarCompany: [],
      categories: app.categories.map(category => category.名称) || [],
    }
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          localStorage.setItem(this.componentName+(this.$route.params.id||''), JSON.stringify(newVal))
        }
      },
      deep: true
    },
    $route: {
      handler: function(val, oldVal){
        if (val.params.id) {
          this.formData = {}
          this.initOther()
        } else {
          this.formData = {}
          this.$emit('closeTpl')
        }
      }
    }
  },
  methods: {
    async loadRadish() {
      const rid = this.item.rid || this.$route.params.id
      const res = await app.service('radish').simpleFetch({
        _id: rid, fields: { 姓名: 1, 公司: 1, 职能模块: 1 }
      })
      if (res.status == 'success' && res.data) {
        this.radish = res.data
      }
    },
    async submit() {
      if (this.submiting) return this.$message('正在保存中，请稍候')
      if (Object.values(this.formData).every(dt=>(!dt || dt.length == 0))) return this.$message('您没有填写任何内容')
      if (!this.radish._id) return this.$message('没有人选数据')
      if (!this.company._id) return this.$message('没有公司数据')
      this.submiting = true
      if (this.radish._id) {
        if (this.company._id) {
          // 保存阿尔法认知
          this.saveAlphaRenzhiWord()
        }

        // 更新底层页面数据
        app.root.$refs.main.init && app.root.$refs.main.init()

        this.formData = {}
        localStorage.removeItem(this.componentName+(this.$route.params.id||''))
        this.submiting = false
        this.$emit('closeTpl', {msg: '小阿已为您保存完毕'})
      }
    },
    async loadCompany() {
      if (this.radish.公司) {
        const res = await app.service('company').getCompanySimpleList({
          query: { $or: [{ 公司名称: this.radish.公司 }, { 简称: this.radish.公司 }] },
          fields: { 简称: 1, 公司备注: 1, 阿尔法认知: 1 },
        })
        if (res.status == 'success') {
          if (res.data && res.data.length > 0) {
            this.company = res.data[0]
            this.alphaRenzhi = {
              公司备注: res.data[0].公司备注 || '',
              阿尔法认知: res.data[0].阿尔法认知 || [],
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async saveAlphaRenzhiWord() {
      let alphaRenzhiWord = ''
      this.alphaRenzhiFields.forEach(item=>{
        if (this.formData[item.value]) {
          alphaRenzhiWord += `${item.label}：${this.formData[item.value]}\n`
        }
      })
      if (!alphaRenzhiWord) return
      const log = {
        createdAt: Date.now(),
        account: app.user.account,
        content: alphaRenzhiWord,
      }
      const res = await app.service('company').alphaCognitiveAddLog({
        cid: this.company._id,
        log: log,
      })
      if (res.status === 'success') {
        this.alphaRenzhi.阿尔法认知 = res.data
        alphaRenzhiWord = ''
      } else {
        this.$message(res.msg)
      }
    },
    async searchCompany() {
      const hasCom = await app.service('company').checkHasCompany(this.radish.公司)
      if (hasCom.status == 'success' && hasCom.companyName) {
        this.radish.公司 = hasCom.companyName
        this.changeCompany()
      } else {
        const simiCom = await app.service('company').serchCompany(this.radish.公司)
        if (simiCom.status == 200) {
          this.similarCompany = simiCom.data
        }
        this.showChooseCompany = true
      }
    },
    chooseCompany(name) {
      this.showChooseCompany = false
      this.radish.公司 = name
      this.changeCompany()
    },
    async changeCompany() {
      await this.loadCompany()
      if (this.radish.公司) {
        await app.service('radish').modifyById({ _id: this.radish._id, data: {公司: this.radish.公司} })
      }
    },
    async gotoCompany() {
      this.showChooseCompany = false
      window.open(`${window.origin}/#/NewAddCompany?companyName=${this.radish.公司}`, '_blank')
    },
    async initData(defaultForm) {
      console.log('initData')
      this.formData = defaultForm || {}
      await this.initOther()
    },
    async initOther() {
      await this.loadRadish()
      await this.loadCompany()
      // console.log('init', this.radish, this.company)
    }
  }
}
</script>
